export function isPortalUnderMaintenance(user) {
  if (!user) return false;

  const values = [
    user.portal_under_maintenance,
    user.organization_details?.portal_under_maintenance,
  ];

  return values.some(
    (value) => value === true || value === "true" || value === 1 || value === "1"
  );
}

export function getMaintenanceDowntime(user) {
  const org = user?.organization_details || {};
  const raw =
    org.portal_maintenance_estimated_downtime ||
    org.estimated_downtime ||
    org.portal_under_maintenance_duration ||
    user?.portal_maintenance_estimated_downtime ||
    user?.estimated_downtime;

  if (raw == null || raw === "") return "30 Minutes";
  if (typeof raw === "number") {
    return `${raw} Minute${raw === 1 ? "" : "s"}`;
  }

  const text = String(raw).trim();
  if (/^\d+$/.test(text)) {
    const minutes = Number(text);
    return `${minutes} Minute${minutes === 1 ? "" : "s"}`;
  }

  return text;
}
